<template>
  <div class="popup_in">
    <div class="popup pop-blocked">
      <div class=""><BlockedBlue /></div>
      <div class="title bold tx--blue2">{{ title }}<br /></div>
      <div class="pop-blocked-date">
        <div>{{ block.end_date }}</div>
        {{ block.start_time }}-{{ block.end_time }}
      </div>
      <div class="text let-1">
        {{ insurance }} {{ block.dup_blocks.length > 1 ? "" : "(ללא חזרה)" }}
      </div>
      <a class="bt_blue w-100" @click="close" href="javascript:void(0);"
        >סגירה</a
      >
    </div>
  </div>
  <!-- End pop-blocked -->
</template>

<script>
import BlockedBlue from "@/assets/img/svg/blocked-blue.svg";

export default {
  name: "BlockDisabled",
  props: ["block", "title"],
  data() {
    return {
      app_info: ""
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$root.$emit("refreshBlock");
      this.$emit("close");
    }
  },
  computed: {
    insurance() {
      let ins = [];
      let all_ob = this.block.appointments_ob;
      for (const key in all_ob) {
        if (ins.indexOf(all_ob[key].insurance) < 0) {
          ins.push(all_ob[key].insurance);
        }
      }
      return ins.join(",");
    }
  },
  components: {
    BlockedBlue
  }
};
</script>

<style scoped></style>
